import Vue from 'vue';

Vue.component('equalizer', {
	template: `<span class="equalizer">
					<span class="eq1"></span>
					<span class="eq2"></span>
					<span class="eq3"></span>
					<span class="eq4"></span>
					<span class="eq5"></span>
			    </span>`
});



// WEBPACK FOOTER //
// ./Content/js/app/components/vc-equalizer-animation.js